import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import rpCookie from 'rp-cookie';
import TabList from '../TabList';
import styles from './TabsHeader.scss';

// This component is created
// So the header could escape the bounderies of max-width styles
const HeaderPortal = ({ children }) => ReactDOM.createPortal(
  children,
  document.getElementById('my-account-header'),
);

/**
 * <TabHeader /> component should be passed as property 'headerComponent'
 *
 * @param title <Tabs /> title
 * @param email should passed somehow
 * @param children as <TabList /> component
 */
function TabHeader({ title, email, children }) {
  const handleLogout = () => {
    const userIdCookie = rpCookie.sharedPermanent.get('rp_uid');
    const lastLoggedDateWeb = rpCookie.sharedSession.get('rp_last_logged_in_date_web');

    localStorage.setItem('recentLogoutData', JSON.stringify({
      isLoggedOut: true,
      userId: JSON.parse(userIdCookie) || '',
      lastLoggedDateWeb: lastLoggedDateWeb || '',
    }));
    window.authApi.logout();
  };

  return (
    <div className={styles.root}>
      <HeaderPortal>
        <div className={styles.header}>
          <div className={styles.headerContainer}>
            <div className={styles.headerTitleContainer}>
              <span
                className={styles.headerTitle}
              >{title}
              </span>
            </div>
            <button className={styles.logout} onClick={handleLogout}>Log out</button>
          </div>
        </div>
      </HeaderPortal>
      <div className={styles.details}>
        {children}
        <h2 className={styles.heading}>
          <img className={styles.icon} src="/svgs/user_email.svg" alt="User" />
          <span className={styles.email}>{email}</span>
        </h2>
      </div>
    </div>
  );
}

TabHeader.propTypes = {
  title: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  children: PropTypes.instanceOf(TabList).isRequired,
};

export { TabHeader as default };

